import _toConsumableArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { _ as _objectSpread2 } from '../_rollupPluginBabelHelpers-05128ded.js';
import React__default, { useState } from 'react';
var IconButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    children = props.children,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$width = props.width,
    width = _props$width === void 0 ? '56px' : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? '56px' : _props$height,
    _props$type = props.type,
    type = _props$type === void 0 ? 'button' : _props$type,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$onBlur = props.onBlur,
    _onBlur = _props$onBlur === void 0 ? function () {/* noop */} : _props$onBlur,
    _props$onClick = props.onClick,
    _onClick = _props$onClick === void 0 ? function () {/* noop */} : _props$onClick;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPressed = _useState2[0],
    setIsPressed = _useState2[1];
  return /*#__PURE__*/React__default.createElement("button", {
    className: [].concat(_toConsumableArray(Array.isArray(className) ? className : [className]), ['sendbird-iconbutton', isPressed ? 'sendbird-iconbutton--pressed' : '']).join(' '),
    disabled: disabled,
    ref: ref,
    type: type,
    style: _objectSpread2(_objectSpread2({}, style), {}, {
      height: height,
      width: width
    }),
    onClick: function onClick(e) {
      if (disabled) {
        return;
      }
      setIsPressed(true);
      _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
    },
    onBlur: function onBlur(e) {
      setIsPressed(false);
      _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur(e);
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "sendbird-iconbutton__inner"
  }, children));
});
export { IconButton as default };